// extracted by mini-css-extract-plugin
module.exports = {"root":"MyLocation_root__1KJIJ","icon":"MyLocation_icon__2fkOQ"};